import { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';

// ----------------------------------------------------------------------

export type RouterLinkProps = Omit<LinkProps, 'to'> & {
  // `href` (not `to`) so MUI components can pass it through when used via `component={RouterLink}`.
  // Optional because action-only nav items (logout, external links) drive behavior through
  // onClick and have no route; they fall back to a no-op self-link below.
  href?: string;
};

const RouterLink = forwardRef<HTMLAnchorElement, RouterLinkProps>(({ href, ...other }, ref) => (
  <Link ref={ref} to={href ?? ''} {...other} />
));

export default RouterLink;
